import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { signupUser, fetchSignupFields } from '../actions';
import { SignupState } from '../types';
import { ISignupState } from '../../../interfaces';

const initialState: SignupState = {
  data: null,
  isLoading: false,
  error: null,
  fields: [],
  fieldsLoading: false,
  fieldsError: null,
};

export const signupSlice = createSlice({
  name: 'signup',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(signupUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(signupUser.fulfilled, (state, action: PayloadAction<ISignupState>) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(signupUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchSignupFields.pending, (state) => {
        state.fieldsLoading = true;
        state.fieldsError = null;
      })
      .addCase(fetchSignupFields.fulfilled, (state, action) => {
        state.fieldsLoading = false;
        state.fields = action.payload;
      })
      .addCase(fetchSignupFields.rejected, (state, action) => {
        state.fieldsLoading = false;
        state.fieldsError = action.payload as string;
      });
  },
});

export default signupSlice.reducer;
